import {
  WS_EIGHT_WEEKS,
  WS_ELEVEN_WEEKS,
  WS_FIVE_WEEKS,
  WS_FOUR_WEEKS,
  WS_NINE_WEEKS,
  WS_ONE_DAY,
  WS_ONE_WEEK,
  WS_SEVEN_WEEKS,
  WS_SIX_WEEKS,
  WS_TEN_WEEKS,
  WS_THREE_WEEKS,
  WS_TWELVE_WEEKS,
  WS_TWO_WEEKS,
} from '@pages/WorkSchedule/constants/filters';

import type { BaseOptionType } from 'antd/es/select';

export const periodOptions: BaseOptionType[] = [
  { value: WS_ONE_DAY, label: '1 день' },
  { value: WS_ONE_WEEK, label: '1 неделя' },
  { value: WS_TWO_WEEKS, label: '2 недели' },
  { value: WS_THREE_WEEKS, label: '3 недели' },
  { value: WS_FOUR_WEEKS, label: '4 недели' },
  { value: WS_FIVE_WEEKS, label: '5 недель' },
  { value: WS_SIX_WEEKS, label: '6 недель' },
  { value: WS_SEVEN_WEEKS, label: '7 недель' },
  { value: WS_EIGHT_WEEKS, label: '8 недель' },
  { value: WS_NINE_WEEKS, label: '9 недель' },
  { value: WS_TEN_WEEKS, label: '10 недель' },
  { value: WS_ELEVEN_WEEKS, label: '11 недель' },
  { value: WS_TWELVE_WEEKS, label: '12 недель' },
];
